<h1 *ngIf="model.PrelevementVitesse.Vitesse || model.IsForMGCE" mat-dialog-title class="p-2 text-center">P{{model.Prelevement.Numero}}</h1>
<div mat-dialog-content>
    <div class="row">

        <div *ngIf="(model.InterventionType === EInterventionType.IBGN || model.InterventionType === EInterventionType.MPCE) && hasMultipleSubstrat()" class="col-12 col-md-6">
            <mat-form-field class="w-100">
                <mat-label>Sous substrat</mat-label>
                <mat-select placeholder="Sous substrat" [(ngModel)]="model.Prelevement.SousSubstrat">
                    <mat-option *ngFor="let c of SousSubstratList; let i = index" [value]="c.idx">
                        <span>{{c.s}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="!model.IsForMGCE" class="col-12 col-md-6">
            <mat-form-field class="w-100">
                <mat-label>Vitesse</mat-label>
                <input matInput placeholder="Vitesse" [ngModel]="getClasseVitesseName(model.PrelevementVitesse.Vitesse)" disabled>
            </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
            <mat-form-field class="w-100">
                <mat-label>Profondeur (cm)</mat-label>
                <input matInput placeholder="Profondeur (cm)" type="number" [(ngModel)]="model.Prelevement.Profondeur" required>
            </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
            <mat-form-field class="w-100">
                <mat-label>Colmatage</mat-label>
                <mat-select placeholder="Colmatage" [(ngModel)]="model.Prelevement.Colmatage">
                    <mat-option *ngFor="let c of ColmatageLitList; let i = index" [value]="i + 1">
                        <span>{{c}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
            <mat-form-field class="w-100">
                <mat-label>Intensité</mat-label>
                <mat-select placeholder="Intensité" [(ngModel)]="model.Prelevement.Intensite" [disabled]="model.Prelevement.Colmatage === undefined || model.Prelevement.Colmatage === 1">
                    <mat-option *ngFor="let s of IntensiteList; let i = index" [value]="i + 1">
                        <span>{{s}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
            <mat-form-field class="w-100">
                <mat-label>Végétation</mat-label>
                <mat-select placeholder="Végétation" [(ngModel)]="model.Prelevement.Vegetation">
                    <mat-option *ngFor="let n of NatureVegetationPlacetteList; " [value]="n.idx">
                        <span>{{n.s}}</span>
                    </mat-option>
                </mat-select>
                <!-- <input matInput placeholder="Végétation" [(ngModel)]="model.Prelevement.Vegetation" > -->
            </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
            <mat-form-field class="w-100">
                <mat-label>Abondance</mat-label>
                <mat-select placeholder="Abondance" [(ngModel)]="model.Prelevement.Abondance" [disabled]="model.Prelevement.Vegetation === undefined || model.Prelevement.Vegetation === 0">
                    <mat-option *ngFor="let a of AbondanceList; let i = index" [value]="i">
                        <span>{{a}}</span>
                    </mat-option>
                </mat-select>
                <!-- <input matInput placeholder="Abondance" type="number" [(ngModel)]="model.Prelevement.Abondance" > -->
            </mat-form-field>
        </div>

        <div class="col-12">
            <mat-form-field class="w-100">
                <mat-label>Outil</mat-label>
                <mat-select placeholder="Outil" [(ngModel)]="model.Prelevement.Materiel" required>
                    <mat-option *ngFor="let s of MaterielList; let i = index" [value]="i + 1">
                        <span>{{s}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-form-field class="col-12">
            <mat-label>Commentaire</mat-label>
            <textarea matInput placeholder="Commentaire" type="number" [(ngModel)]="model.Prelevement.Commentaire"></textarea>
        </mat-form-field>

        <div class="d-flex justify-content-center align-items-center" style="height: 30px;">
            <div style="color: red;" *ngIf="model.Prelevement.Profondeur > 60 && model.Prelevement.Materiel === 1">
                Etes-vous sûr d'avoir prélevé avec surber ?!
            </div>
        </div>
        <button appPreventDoubleClick class="col-6 squared-flat-button" color="primary" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col-6 squared-flat-button" color="warn" mat-stroked-button (throttledClick)="onConfirm()" [disabled]="!CanAdd">
            Sauvegarder
        </button>
    </div>
</div>